import { API_HOST } from '../../App'

// export function makeFormData(values, ...fields) {
//     let fd = new FormData() //formDataForSubmit
//       , fs = new Set(fields)
//       , bad = new Map() //errors

//     for (let k in values) {
//         if (fs.has(k) || fs.size === 0) {
//             let v = values[k]
//             if (!v) {
//                 bad.set(k, v)
//             } else {
//                 fd.append(k, v)
//             }
//         }
//     }
//     return bad.size > 0 ? bad : fd
// }

// Простите, но это невозможно читать


// Эта функция исключает поля, котoрые undefined или false
// и валидирует как бы
// короче это похоже на костыль 
//(потому что не смогли понять, почему не работают checkbox) и выпилили все поля с чекбоксами

//{key: values} -- это field
//fields -- поля которые определились (не undefined)
export function makeFormData(antdFormFields, ...fieldKeys) { //antdFormFields - values   ///// fields - fieldKeys    
    let formDataForSubmit = new FormData();                  //formDataForSubmit - fd
    let keysSet = new Set(fieldKeys);                        //fieldsSet - fs    ///keysSet - fieldsSet
    let errors = new Map();                                  //errors //bad

    for (let currentAntdKey in antdFormFields) {                         //currentAntdKey - k 

        if (keysSet.has(currentAntdKey) || keysSet.size === 0) {
            let currentAntdValue = antdFormFields[currentAntdKey];       //currentAntdValue - v

            if (!currentAntdValue) { //если значение поля undefined или false
                errors.set(currentAntdKey, currentAntdValue)
            } else {
                formDataForSubmit.append(currentAntdKey, currentAntdValue)
            }
        }
    }
    return errors.size > 0 ? errors : formDataForSubmit;
}

export function prepareImageUrl(url) {
    return API_HOST + "/" + url
}
